import { useQuery } from "@tanstack/react-query"
import { DateTime } from "luxon"

import type { TagPath } from "@/types/dataPointTypes.ts"

import { getTagIntervals } from "../api/getTagIntervals.ts"

import DataPointValueTable from "./DataPointValueTable.tsx"

export default function TagPreview({ path }: { path: TagPath }) {
  const { data } = useQuery({
    queryKey: ["tagPreview", path],
    queryFn: () =>
      getTagIntervals(path, {
        start: DateTime.now().minus({ days: 1 }).toJSDate(),
        end: DateTime.now().minus({ seconds: 1 }).toJSDate(),
        interval: 3600,
        aggMode: "Average",
      }),
  })

  return (
    <div className="h-full">
      <DataPointValueTable data={data || []} />
    </div>
  )
}
